import { shallowMount } from "@vue/test-utils";
import CheckBox from "@/components/core/custom/CheckBox";

describe("CheckBox component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CheckBox);
  });

  it("Renders del component CheckBox", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
